import React, { useState } from "react";

import { Box } from "@chakra-ui/react";
import { activateOrDeactivateODPRollOverConfig } from "api/business-user-management";
import { ReactComponent as InfoOutlineIcon } from "assets/icons/info-outline.svg";
import { useParams } from "react-router-dom";

import { Button } from "ui/button";
import { customErrorToast, customSuccessToast } from "ui/custom-toast";
import { Modal } from "ui/modal";
import { ModalHeader } from "ui/modal/modal-header";
import { defaultModalCss } from "ui/modal/styles";
import { Heading3, Paragraph3 } from "ui/typography";

import { transactionLimitModalHeaderCss } from "../../styles";
import { IActivateDeactivateRollOverModalProps } from "./types";

export const ActivateRollOverModal = (
  props: IActivateDeactivateRollOverModalProps
) => {
  const { isOpen, setIsOpen, handleToggleModal, setOdpConfig } = props;
  const { businessId } = useParams();
  const [isActivating, setIsActivating] = useState(false);

  const handleActivateRollOver = async () => {
    if (!businessId) {
      console.error("Error: business id is absent! ");
      return;
    }
    setIsActivating(true);
    try {
      const { error, message, data } =
        await activateOrDeactivateODPRollOverConfig({
          businessId,
          isActivate: true,
        });
      if (error) {
        customErrorToast({
          message,
        });
      } else if (data) {
        setOdpConfig(data);
        customSuccessToast({
          message: "Roll Over Activated Successfully",
        });
        handleToggleModal();
      }
    } catch (error) {
      console.error("Error: ", error);
    }
    setIsActivating(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      modalCss={{
        ...defaultModalCss,
        width: "400px",
        height: "304px",
        padding: "24px",
        gap: "32px",
      }}
      allowOutsideClick={false}
    >
      <Box className="flex flex-col gap-5">
        <ModalHeader
          modalType="approval"
          modalHeaderCss={transactionLimitModalHeaderCss}
        />
        <Box className="flex flex-col gap-2 h-[128px]">
          <Heading3
            fontSize="18px"
            lineHeight="28px"
            textColor="#101828"
            fontWeight="600"
          >
            Activate Roll Over
          </Heading3>
          <Paragraph3
            lineHeight="20px"
            textColor="#475467"
          >
            Please confirm that you want to perform this action.
          </Paragraph3>
          <Box className="bg-[#FEF5E7] border border-[#FFEFD8] rounded-2xl p-3 flex justify-between items-center gap-[14px]">
            <InfoOutlineIcon className="flex-shrink-0" />
            <Paragraph3
              lineHeight="20px"
              textColor=" #1A202C"
            >
              This business will retain access to On-Demand Pay even when they
              have not paid.
            </Paragraph3>
          </Box>
        </Box>
      </Box>
      <Box
        css={{
          height: "44px",
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        <Button
          variant="outline"
          textColor="#344054"
          border="1px solid #D0D5DD"
          className="w-[170px]"
          onClick={handleToggleModal}
          disabled={isActivating}
        >
          Cancel
        </Button>
        <Button
          variant="solid"
          textColor="#ffffff"
          border="1px solid #00535C"
          className="w-[170px]"
          onClick={handleActivateRollOver}
          disabled={isActivating}
          loading={isActivating}
          loadingText="Activating..."
        >
          Confirm
        </Button>
      </Box>
    </Modal>
  );
};
